module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABEklEQVQ4jZ3SvytFcRjH8ZfTMSk/kh+ZsNlI/A8Gt2SQkpuFyUz5C8jIcBeRlMmETbek2NhsLFY/Bsl0Gc73do/r3qPjU6eeT8/38z7nec63pVQqjeEEg/LpEbMxynjCTE7AOsoxOlDAZU7AMy6jYDpzhqELqoAo42AzRY2CwzjARPAb2A31UOiN/6KkNIBFjAQ/h5VQ99f1QFwHuEI33oKfxFeor0PvNQsAL6n6M6OH2gjvDUB/6SMN6P0HoJ1khDMcSRbUGp57teVVtYQiKpLRpnAaYRpb6AnhCpZxngoXsYe28NV92EYhlmx5re5to7jFAm6wj03J/f+hRn8B7rCKw+CPG4XJvsI7uMAD5psd+gaLjS9lQawDmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_comment.png
// module id = jJWO
// module chunks = 1